import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { ProductCardLayoutType } from '../../common/models/product';
import { useSimpleVisaCardSelection, useSimpleVisaPrice } from '../common/hooks';
import { getPriceProps } from '../../common/utils/productCardProps';
import { useProductData } from '../../common/hook/useProductData';
import { SIMPLE_VISA } from '../../products';
import ProductLayout from '../../common/main-layout/ProductLayout';
import SimpleVisaContent from '../common/SimpleVisaContent';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import SimpleVisaLogo from './SimpleVisaLogo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = SIMPLE_VISA;
const logoWrapperStyles = css`
  grid-area: 3 / 1 / 4 / 2;
`;
const sharedTexts = {
  readMoreContent: 'simpleVisaReadMoreModalContent',
  title: 'simpleVisaTitle',
  noVisaInfo: 'Products.SimpleVisa.Travelers.Nationality.NoVisaInfo.Text',
  visaInfoHeader: 'Products.SimpleVisa.Travelers.Nationality.NoVisaInfo.Header',
  nationalityPlaceholder: 'Products.SimpleVisa.Travelers.Nationality.Placeholder',
  nationalityLabel: 'Products.SimpleVisa.Travelers.Nationality.Label'
};
const mainCardTranslations = {
  ...sharedTexts,
  abstractContent: 'simpleVisaAbstract',
  additionalInformation: 'simpleVisaAdditionalInformation',
  upSell: 'simpleVisaUpSellText',
  persuasionContent: 'simpleVisaPersuasionContent'
};
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: {
    ...mainCardTranslations
  },
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'simpleVisaAbstractSmallCard',
    upSell: 'simpleVisaUpSellTextSmallCard'
  }
};
const SimpleVisaLayout = ({
  className,
  form,
  order,
  cardSelection,
  contactEmail,
  hasAnySelected,
  priceRaw,
  selectProduct,
  selectAllTravelers,
  updateTotalPrice,
  travelers,
  selectTraveler,
  isSelected,
  productCode,
  productPosition,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  const {
    t
  } = useTranslation();
  const texts = translations[layoutType] || {};
  useSimpleVisaPrice(updateTotalPrice, priceRaw);
  const [isOpen] = useSimpleVisaCardSelection(hasAnySelected, cardSelection, selectProduct, selectAllTravelers, travelers);
  const {
    productData,
    rootElement,
    translation
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    texts
  });
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const {
    price,
    priceLabel,
    priceSuffix
  } = getPriceProps(t, isSelected, {
    ...product,
    priceRaw
  });
  const updatedExtraProps = {
    ...(productData === null || productData === void 0 ? void 0 : productData.extraProps),
    noVisaInfo: translation.noVisaInfo,
    visaInfoHeader: translation.visaInfoHeader,
    nationalityPlaceholder: translation.nationalityPlaceholder,
    nationalityLabel: translation.nationalityLabel,
    selectTraveler
  };
  const updatedProductData = {
    ...productData,
    priceRaw,
    price,
    priceLabel,
    priceSuffix,
    extraProps: updatedExtraProps
  };
  switch (layoutType) {
    case ProductCardLayoutType.Small:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        productData: updatedProductData,
        ref: rootElement,
        children: /*#__PURE__*/_jsx(SimpleVisaContent, {
          contactEmail: contactEmail,
          isOpen: isOpen,
          productName: PRODUCT_NAME,
          selectAllTravelers: () => selectAllTravelers(travelers, Boolean(cardSelection)),
          travelers: travelers
        })
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsxs(ProductLayout, {
        productData: updatedProductData,
        ref: rootElement,
        children: [/*#__PURE__*/_jsx(ProductLayout.Body, {
          children: /*#__PURE__*/_jsx("div", {
            className: logoWrapperStyles,
            children: /*#__PURE__*/_jsx(SimpleVisaLogo, {})
          })
        }), /*#__PURE__*/_jsx(SimpleVisaContent, {
          contactEmail: contactEmail,
          isOpen: isOpen,
          productName: PRODUCT_NAME,
          selectAllTravelers: () => selectAllTravelers(travelers, Boolean(cardSelection)),
          travelers: travelers
        })]
      });
  }
};
export default SimpleVisaLayout;
//# sourceMappingURL=SimpleVisaLayout.js.map